// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__2imOE","navTitle":"Navbar_navTitle__3a_w2","navIcon":"Navbar_navIcon__XDck0"};